import { ApiResponse } from '@/types/apiResponse';
import { Game, GetGamesParams } from '@/types/tournament/game';
import { apiService } from '../api';

class GameService {
  private static instance: GameService;
  private games: Game[] = [];

  private constructor() {}

  public static getInstance(): GameService {
    if (!GameService.instance) {
      GameService.instance = new GameService();
    }
    return GameService.instance;
  }

  async getGames(params?: GetGamesParams): Promise<ApiResponse<Game[]>> {
    const response = await apiService.get<ApiResponse<Game[]>>(
      '/public/api/v1/game/getGames',
      params ? { params } : undefined,
    );

    if (!params || Object.keys(params).length === 0) {
      this.games = response.result;
    }

    return response;
  }

  getCachedGames(): Game[] {
    return this.games;
  }

  hasCachedGames(): boolean {
    return this.games.length > 0;
  }
}

export const gameService = GameService.getInstance();

export type { Game };
